export default "__VITE_ASSET__B5Tu6Jty__"